import { GUID } from 'core/utils';
import produce, { Draft, enableES5 } from 'immer';
import { getDefaultSummaryMode } from '../handlers/logic';
import { ActionTypes } from '../models/actions';
import {
  USER_CHANGED_MODE,
  USER_CHANGED_LENGTH_GAUGE,
  USER_CHANGED_ACTIVE_TAB,
  SYSTEM_STARTED_SUMMARIZATION,
  SYSTEM_FINISHED_SUMMARIZATION,
  USER_CLICKED_MODE_EXPANSION_PANEL,
  SYSTEM_ERROR_SUMMARIZATION,
  CHAR_LIMIT_EXCEEDED,
  USER_UPLOADED_FILE,
  SYSTEM_SET_KEYWORDS,
  USER_CLICKED_KEYWORD,
  USER_CLEARED_KEYWORDS,
  LOADING_KEYWORDS,
  USER_CHANGED_INPUT_TEXT,
  HYDRATE_STORE_FROM_SESSION,
} from '../models/actions/names';
import { Controls } from '../models/store';

enableES5();

const initState = {
  isQuilling: false,
  summaryMode: getDefaultSummaryMode(),
  absLengthGauge: 0.2,
  extLengthGauge: 5,
  activeTab: 'original',
  isModePanelExpanded: false,
  showCharLimitMessage: false,
  uploadedFile: {},
  keywords: [],
  selectedKeywords: [],
  loadingKeywords: false,
  submissionID: 'default',
  outputBoxKey: 'outputKey',
};

export const controlReducer = produce((draft: Draft<Controls>, action: ActionTypes) => {
  switch (action.type) {
    case USER_CHANGED_MODE:
      draft.summaryMode = action.payload.summaryMode;
      break;
    case USER_CHANGED_LENGTH_GAUGE: {
      const summaryMode = action.payload.summaryMode;
      const changeInState: { absLengthGauge?: number; extLengthGauge?: number } = {};
      if (summaryMode === 'abs') {
        changeInState.absLengthGauge = action.payload.newValue;
      } else if (summaryMode === 'ext') {
        changeInState.extLengthGauge = action.payload.newValue;
      }
      if (changeInState.absLengthGauge) draft.absLengthGauge = changeInState.absLengthGauge;
      else if (changeInState.extLengthGauge) draft.extLengthGauge = changeInState.extLengthGauge;
      break;
    }
    case USER_CHANGED_ACTIVE_TAB:
      draft.activeTab = action.payload.summaryActivetab;
      break;
    case SYSTEM_STARTED_SUMMARIZATION:
      draft.isQuilling = true;
      draft.keywords = Array.from(new Set([...draft.selectedKeywords, ...draft.keywords]));
      if (action.payload.submissionID) draft.submissionID = action.payload.submissionID;
      draft.showCharLimitMessage = false;

      break;
    case SYSTEM_ERROR_SUMMARIZATION:
      draft.isQuilling = false;
      break;
    case SYSTEM_FINISHED_SUMMARIZATION:
      draft.isQuilling = false;
      draft.activeTab = 'summarized';
      draft.isModePanelExpanded = false;
      return;
    case USER_CLICKED_MODE_EXPANSION_PANEL:
      draft.isModePanelExpanded = !draft.isModePanelExpanded;
      break;
    case CHAR_LIMIT_EXCEEDED:
      draft.showCharLimitMessage = action.payload.charLimitExceded;
      break;
    case USER_UPLOADED_FILE:
      draft.uploadedFile = { ...action.payload };
      break;
    case SYSTEM_SET_KEYWORDS:
      draft.keywords = action.payload;
      if (draft.selectedKeywords.length) {
        draft.selectedKeywords = draft.selectedKeywords.filter((selectedKeyword) =>
          draft.keywords.includes(selectedKeyword)
        );
      }
      draft.loadingKeywords = false;
      draft.keywords = Array.from(new Set([...draft.selectedKeywords, ...draft.keywords]));
      break;
    case USER_CLICKED_KEYWORD:
      if (draft.selectedKeywords.includes(action.payload)) {
        draft.selectedKeywords = draft.selectedKeywords.filter(
          (keyword) => keyword !== action.payload
        );
      } else {
        draft.selectedKeywords = [...draft.selectedKeywords, action.payload];
      }
      break;
    case USER_CLEARED_KEYWORDS:
      draft.selectedKeywords = [];
      break;
    case LOADING_KEYWORDS:
      draft.loadingKeywords = action.loading;
      break;
    case USER_CHANGED_INPUT_TEXT:
      if (!action.payload.inputPara.length) draft.uploadedFile = { fileName: '', fileType: '' };
      break;

    case HYDRATE_STORE_FROM_SESSION: {
      try {
        if (action.payload.src === 'CONTROLS') {
          // eslint-disable-next-line consistent-return
          return { ...draft, ...action.payload.store };
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
      break;
    }

    default:
      break;
  }
}, initState);
